import React from 'react';
import { GoogleMap, OverlayView } from '@react-google-maps/api';

import { ReactComponent as AddressMarker } from '../../assets/map-pin.svg';

const ExploreMap = ({ mapCenter, mapStyle, hasPopup }) => (
  <div className={`relative h-full w-full ${hasPopup ? 'hidden' : ''}`}>
    <GoogleMap
      mapContainerStyle={{ height: '100%', width: '100%' }}
      defaultCenter={mapCenter}
      zoom={15}
      center={mapCenter}
      mapTypeId={'roadmap'}
      options={{
        minZoom: 13,
        zoomControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        mapTypeControl: false,
        styles: mapStyle.styles,
        keyboardShortcuts: false,
      }}
    >
      <MarkerContainer
        position={mapCenter}
        currentActive={true}
        mapType={'roadmap'}
      />
    </GoogleMap>
  </div>
);

const MarkerContainer = ({
  key,
  text,
  type,
  rating,
  onMouseEnter,
  onMouseLeave,
  onClick,
  position,
  currentActive = false,
  mapType,
  toggleStreetView,
  index,
  showCompareLifeStyle,
}) => {
  return (
    <OverlayView
      key={key}
      position={position}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
      shouldRedraw={false}
      getPixelPositionOffset={(width, height) => ({
        x: -width - 44 / 2,
        y: -height - 100 / 2,
      })}
    >
      <div className="animate-bounce">
        <AddressMarker />
      </div>
    </OverlayView>
  );
};

export default ExploreMap;